import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement('path', { d: 'M3.6212257 7.610797c-.157343 0-.3155852-.051249-.4477533-.156444L.54 5.358545l.8955065-1.125677 2.0976071 1.669634L8.3792783.389203 9.46 1.338655 4.1624856 7.36714c-.1420582.16094-.34076.243657-.5412599.243657' }), {
  viewBox: '0 0 10 8',
  width: 10,
  height: 8
});